export default __webpack_public_path__ + "static/media/019-monkey.55cd82b8.svg";